import { useEffect, useRef } from "react";

const useOutsideEvent = (
  refOrRefs,
  eventType = "click",
  callback,
  specialCondition = true,
  enabled = true,
) => {
  const refElementsRefs = useRef();
  refElementsRefs.current = Array.isArray(refOrRefs) ? refOrRefs : [refOrRefs];

  useEffect(() => {
    const handleEvent = (event) => {
      if (!callback) {
        return;
      }

      const isSpecialConditionOK = specialCondition && (
        typeof specialCondition === "function"
          ? specialCondition(event)
          : specialCondition
      );

      if (isSpecialConditionOK && refElementsRefs.current.some((elRef) => {
        return elRef?.current && !elRef.current.contains(event.target);
      })) {
        callback(event);
      }
    };

    if (enabled) {
      document.addEventListener(eventType, handleEvent);
    }

    return () => {
      if (enabled) {
        document.removeEventListener(eventType, handleEvent);
      }
    };
  }, [callback, eventType, specialCondition, enabled]);
};

export default useOutsideEvent;
